/**
 * Словник: es.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_es.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Esperando al otro participante...",
  connectionLost: "Conexión perdida",
  peerLeft: "👋 El otro participante ha salido de la llamada",
  connectionError: "🚫 Error de conexión",
  connectionFailedTryAgain: "🚫 No se pudo conectar con el servidor. Inténtalo de nuevo.",
  reconnectionFailed: "🚫 Conexión perdida. No se pudo restablecer tras {attempts} intentos.",
  connectionErrorWithDetails: "🚫 Error de conexión: {error}",
  speakerLoud: "Altavoz",
  speakerEar: "Auricular",
  copyRoomId: "Copiar ID de sala",
  share: "Compartir",
  linkCopied: "🔗 ¡Enlace copiado!",
  idCopied: "🆔 ¡ID copiado!",
  startMeeting: "Iniciar reunión",
  chooseAction: "Elige una acción",
  createNewRoom: "Nueva sala",
  scheduleCall: "Programar una llamada",
  calendarOpened: "📅 Calendario abierto",
  linkCopiedToClipboard: "🔗 Enlace copiado al portapapeles",
  enterRoomId: "ID de la sala",
  roomIdValidationError: "El ID de sala solo puede contener letras, números y guiones",
  joinRoom: "UNIRSE",
  termsAndPrivacyHelp: "Términos y privacidad | Ayuda",
  invite: "Invitar",
  mySettings: "Mis ajustes",
  peerSettings: "Ajustes de la otra persona",
  blockRemoteControl: "Bloquear el control remoto",
  iAgreeToTerms: "Acepto los términos del servicio",
  termsOfUse: "Términos de uso",
  privacyPolicy: "Política de privacidad",
  howToUse: "Cómo se usa",
  termsAcceptanceRequired: "Debes aceptar los términos para usar el servicio",
  ok: "OK",
  permissionsRequired: "Permisos necesarios",
  permissionsNeededMessage: "Esta app necesita los siguientes permisos para funcionar correctamente:",
  permissionsNote: "Nota: cuando cambias los permisos en Ajustes, iOS reinicia la app. Es un comportamiento normal.",
  permissionsEnableMessage: "Para continuar, activa estos permisos en la configuración del dispositivo.",
  cancel: "Cancelar",
  openSettings: "Abrir configuración",
  websocketError: "Error de WebSocket",
  roomFull: "La sala está llena",
  timeExpired: "Tiempo agotado",
  remaining: "rest.",
  mediaPermissionsRequired: "Las videollamadas requieren acceso a la cámara y al micrófono. Concede los permisos en tu navegador.",
  mediaPermissionsRequiredMobile: "Las videollamadas requieren acceso a la cámara y al micrófono. Concede los permisos en la configuración de la app.",
  browserSettings: "Configuración del navegador",
  openAppSettings: "Abrir configuración",
  grantPermissions: "Conceder permisos",
  permissionsNotGranted: "Permisos no concedidos. Concédelos para continuar.",
  permissionRequestError: "Error al solicitar permisos: {error}",
  camera: "Cámara",
  microphone: "Micrófono",
  cameraDescription: "Para transmitir video",
  microphoneDescription: "Para transmitir audio",
  continueWithoutPermissions: "Continuar sin permisos",
  mediaPermissionsRequiredFallback: "Las videollamadas necesitan permisos multimedia. Concédelos en la configuración del navegador.",
  mediaPermissionsRequiredMobileFallback: "Las videollamadas necesitan permisos multimedia. Concédelos en la configuración de la app.",
  browserSettingsFallback: "Configuración del navegador",
  openAppSettingsFallback: "Abrir configuración",
  permissionsPermanentlyDenied: "Permisos denegados de forma permanente. Actívalos en la configuración de la app.",
  continueText: "Continuar",
  mirror: "Espejo",
  fitContain: "Ajustar",
  fitCover: "Llenar",
  switchCamera: "Cambiar",
  block: "Bloquear",
  pip: "PiP",
  mic: "Micro",
  video: "Video",
  speaker: "Altavoz",
  readyToConnect: "¿Todo listo para conectar?",
  startOneOnOne: "Iniciar videollamada",
  createPrivateLink: "Enlace listo en un segundo",
  welcomeExplainer: "Crea un enlace y envíalo a quien quieras. Se abre incluso sin la app.",
  joinHaveLink: "¿Tienes un enlace?",
  joinFieldHint: "Pega un enlace o un ID",
  roomInputInvalid: "Pega un enlace de llamada o un ID de sala (letras, números y guiones)",
  guestTitle: "Te han invitado a una videollamada",
  guestBody: "La sala está lista. La otra persona te verá en cuanto te unas.",
  guestJoin: "Unirse",
  guestFreeNote: "Unirse siempre es gratis",
  guestCreateOwn: "Crear mi propia sala",
  guestInvalidTitle: "Este enlace parece dañado",
  guestInvalidBody: "Pide que te envíen el enlace de nuevo o crea tu propia sala.",
  inviteCardTitle: "Tu sala está lista",
  inviteCardBody: "Envía el enlace a la persona con la que quieres hablar",
  inviteShareLink: "Compartir enlace",
  inviteCopy: "Copiar",
  inviteBrowserHint: "Se abre en cualquier navegador. No hace falta instalar la app.",
  inviteSentHint: "¿Enviado? La otra persona aparecerá aquí en cuanto abra el enlace.",
  inviteShareMessage: "Únete a mi videollamada en One2One 👋\nSolo tienes que abrir el enlace. Funciona en el navegador, no hay que instalar nada:\n{link}",
  copyLink: "Copiar enlace",
  consentBannerText: "¿Podemos recopilar estadísticas de uso? Nos muestran qué funciones se usan. El contenido de las llamadas nunca se incluye.",
  consentAllow: "Permitir",
  consentDeny: "No permitir",
  privacySettingsLink: "Ajustes de estadísticas",
} as const;
